import { head } from 'ramda'
import React from 'react'

import { useChecklists } from '../_load/ChecklistsLoader'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useChecklistActionsList } from '../../../../utils/actions/checklist/list'

const MultiRowsActions = () => {
  const checklists = useChecklists()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedChecklists = getSelectedData(checklists)
  const [menuOptions, loading] = useChecklistActionsList(head(selectedChecklists), selecteds)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
